import Vue from 'vue'
import * as types from '../mutations-types'
import {createActionHelpers, fetchAlertsByIds} from 'vuex-loading'
import {fetchAlerts} from '../../utils/api'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})
// STATE
const state = {
  alerts: [],
  selectedAlertGroup: null
}
// GETTERS
const getters = {
  getAlerts: state => state.alerts,
  getUnreadAlertsNumber: state => {
    return state.alerts.filter((alert) => {
      return alert.status === 'UNREAD'
    }).length
  },
  getSelectedGroupAlert: state => state.getSelectedGroupAlert
}
// ACTIONS
const actions = {
  fetchAlerts({commit, dispatch}) {
    return new Promise(async(resolve, reject) => {
      let {data: alerts} = await startLoading(dispatch, 'fetchingAlerts', () => {
        return fetchAlerts()
      })
      if ('data' in alerts) {
        alerts.data = alerts.data.map(alert => {
          const dates = alert.dates.split(',')
          return {
            ...alert,
            from: dates[1],
            to: dates[0]
          }
        })
        commit(types.FETCH_ALERTS, alerts.data)
        resolve(alerts)
      } else {
        reject(new Error('Error at Fetch Alerts'))
      }
    })
  },
  newAlert({commit}, alert) {
    commit(types.ADD_ALERT, alert)
  },
  fetchAlertsByIds({commit, dispatch}, alertsIds) {
    return new Promise(async(resolve, reject) => {
      const {data: alerts} = await startLoading(dispatch, 'fetchingSpecificAlerts', () => {
        return fetchAlertsByIds(alertsIds)
      })
      if (alerts) {
        resolve(alerts)
      } else {
        reject(new Error('Error Fetch Alert By Id'))
      }
    })
  }
}
// MUTATIONS
const mutations = {
  [types.FETCH_ALERTS](state, alerts) {
    state.alerts = alerts
  },
  [types.ADD_ALERT](state, alert) {
    state.alerts.push(alert)
  },
  [types.UPDATE_ALERT](state, updatedAlert) {
    const index = state.alerts.findIndex(alert => alert.id === updatedAlert.id)
    Vue.set(state.alerts, index, updatedAlert)
  },
  [types.SELECT_GROUP_ALERT](state, alertGroup) {
    state.selectedAlertGroup = alertGroup
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alerts.js